import {
    GETGENERALOPDBODYCHART,
    CREATEGENERALOPDBODYCHART,
    UPDATEGENERALOPDBODYCHART,
    DELETEGENERALOPDBODYCHART,
    GETGENERALOPDPAINASSESSMENT,
    CREATEGENERALOPDPAINASSESSMENT,
    UPDATEGENERALOPDPAINASSESSMENT,
    DELETEGENERALOPDPAINASSESSMENT,
    GETGENERALOPDCHIEFCOMPLAINT,
    CREATEGENERALOPDCHIEFCOMPLAINT,
    UPDATEGENERALOPDCHIEFCOMPLAINT,
    DELETEGENERALOPDCHIEFCOMPLAINT,
    GETGENERALOPDASSOCIATEDCOMPLAINT,
    CREATEGENERALOPDASSOCIATEDCOMPLAINT,
    UPDATEGENERALOPDASSOCIATEDCOMPLAINT,
    DELETEGENERALOPDASSOCIATEDCOMPLAINT,
    GETGENERALOPDPRESENTILLNESSHIST,
    CREATEGENERALOPDPRESENTILLNESSHIST,
    UPDATEGENERALOPDPRESENTILLNESSHIST,
    DELETEGENERALOPDPRESENTILLNESSHIST,
    GETGENERALOPDCHIDLILLNESSHIST,
    CREATEGENERALOPDCHIDLILLNESSHIST,
    UPDATEGENERALOPDCHIDLILLNESSHIST,
    DELETEGENERALOPDCHIDLILLNESSHIST,
    GETGENERALOPDADULTILLNESSHIST,
    CREATEGENERALOPDADULTILLNESSHIST,
    UPDATEGENERALOPDADULTILLNESSHIST,
    DELETEGENERALOPDADULTILLNESSHIST,
    GETGENERALOPDHEALTHMAINHIST,
    CREATEGENERALOPDHEALTHMAINHIST,
    UPDATEGENERALOPDHEALTHMAINHIST,
    DELETEGENERALOPDHEALTHMAINHIST,
    GETGENERALOPDPASTILLNESSNOTE,
    CREATEGENERALOPDPASTILLNESSNOTE,
    UPDATEGENERALOPDPASTILLNESSNOTE,
    DELETEGENERALOPDPASTILLNESSNOTE,
    GETGENERALOPDRELATIONHIST,
    CREATEGENERALOPDRELATIONHIST,
    UPDATEGENERALOPDRELATIONHIST,
    DELETEGENERALOPDRELATIONHIST,
    GETGENERALOPDFAMILYSYMPTOMHIST,
    CREATEGENERALOPDFAMILYSYMPTOMHIST,
    UPDATEGENERALOPDFAMILYSYMPTOMHIST,
    DELETEGENERALOPDFAMILYSYMPTOMHIST,
    GETGENERALOPDFAMILYCOMORBIDITYHIST,
    CREATEGENERALOPDFAMILYCOMORBIDITYHIST,
    UPDATEGENERALOPDFAMILYCOMORBIDITYHIST,
    DELETEGENERALOPDFAMILYCOMORBIDITYHIST,
    GETGENERALOPDFAMILYHISTNOTE,
    CREATEGENERALOPDFAMILYHISTNOTE,
    UPDATEGENERALOPDFAMILYHISTNOTE,
    DELETEGENERALOPDFAMILYHISTNOTE,
    GETGENERALOPDPERSONALDIETHIST,
    CREATEGENERALOPDPERSONALDIETHIST,
    UPDATEGENERALOPDPERSONALDIETHIST,
    DELETEGENERALOPDPERSONALDIETHIST,
    GETGENERALOPDAPPETITEHIST,
    CREATEGENERALOPDAPPETITEHIST,
    UPDATEGENERALOPDAPPETITEHIST,
    DELETEGENERALOPDAPPETITEHIST,
    GETGENERALOPDDIGESTIVETRACTHIST,
    CREATEGENERALOPDDIGESTIVETRACTHIST,
    UPDATEGENERALOPDDIGESTIVETRACTHIST,
    DELETEGENERALOPDDIGESTIVETRACTHIST,
    GETGENERALOPDBOWELHIST,
    CREATEGENERALOPDBOWELHIST,
    UPDATEGENERALOPDBOWELHIST,
    DELETEGENERALOPDBOWELHIST,
    GETGENERALOPDSLEEPHIST,
    CREATEGENERALOPDSLEEPHIST,
    UPDATEGENERALOPDSLEEPHIST,
    DELETEGENERALOPDSLEEPHIST,
    GETGENERALOPDADDICTIONHIST,
    CREATEGENERALOPDADDICTIONHIST,
    UPDATEGENERALOPDADDICTIONHIST,
    DELETEGENERALOPDADDICTIONHIST,
    GETGENERALOPDHIGHRISKHIST,
    CREATEGENERALOPDHIGHRISKHIST,
    UPDATEGENERALOPDHIGHRISKHIST,
    DELETEGENERALOPDHIGHRISKHIST,
    GETGENERALOPDPOSITIONODWORK,
    CREATEGENERALOPDPOSITIONODWORK,
    UPDATEGENERALOPDPOSITIONODWORK,
    DELETEGENERALOPDPOSITIONODWORK,
    GETGENERALOPDNATUREOFWORK,
    CREATEGENERALOPDNATUREOFWORK,
    UPDATEGENERALOPDNATUREOFWORK,
    DELETEGENERALOPDNATUREOFWORK,
    GETGENERALOPDOCCUPATIONALHIST,
    CREATEGENERALOPDOCCUPATIONALHIST,
    UPDATEGENERALOPDOCCUPATIONALHIST,
    DELETEGENERALOPDOCCUPATIONALHIST,
    GETGENERALOPDALLOPTHYMEDIHIST,
    CREATEGENERALOPDALLOPTHYMEDIHIST,
    UPDATEGENERALOPDALLOPTHYMEDIHIST,
    DELETEGENERALOPDALLOPTHYMEDIHIST,
    GETGENERALOPDAYURVEDAMEDIHIST,
    CREATEGENERALOPDAYURVEDAMEDIHIST,
    UPDATEGENERALOPDAYURVEDAMEDIHIST,
    DELETEGENERALOPDAYURVEDAMEDIHIST,
    GETGENERALOPDHOMEOPATHYMEDIHIST,
    CREATEGENERALOPDHOMEOPATHYMEDIHIST,
    UPDATEGENERALOPDHOMEOPATHYMEDIHIST,
    DELETEGENERALOPDHOMEOPATHYMEDIHIST,
    GETGENERALOPDOTHERMEDIHIST,
    CREATEGENERALOPDOTHERMEDIHIST,
    UPDATEGENERALOPDOTHERMEDIHIST,
    DELETEGENERALOPDOTHERMEDIHIST,
    GETGENERALOPDANXIETYHIST,
    CREATEGENERALOPDANXIETYHIST,
    UPDATEGENERALOPDANXIETYHIST,
    DELETEGENERALOPDANXIETYHIST,
    GETGENERALOPDDEPRESSIONHIST,
    CREATEGENERALOPDDEPRESSIONHIST,
    UPDATEGENERALOPDDEPRESSIONHIST,
    DELETEGENERALOPDDEPRESSIONHIST,
    GETGENERALOPDIRRITABILITYHIST,
    CREATEGENERALOPDIRRITABILITYHIST,
    UPDATEGENERALOPDIRRITABILITYHIST,
    DELETEGENERALOPDIRRITABILITYHIST,
    GETGENERALOPDEUPHORIAHIST,
    CREATEGENERALOPDEUPHORIAHIST,
    UPDATEGENERALOPDEUPHORIAHIST,
    DELETEGENERALOPDEUPHORIAHIST,
    GETGENERALOPDOBSESSION,
    CREATEGENERALOPDOBSESSION,
    UPDATEGENERALOPDOBSESSION,
    DELETEGENERALOPDOBSESSION,
    GETGENERALOPDNEUROSISHIST,
    CREATEGENERALOPDNEUROSISHIST,
    UPDATEGENERALOPDNEUROSISHIST,
    DELETEGENERALOPDNEUROSISHIST,
    GETGENERALOPDDEPERSONALIZATION,
    CREATEGENERALOPDDEPERSONALIZATION,
    UPDATEGENERALOPDDEPERSONALIZATION,
    DELETEGENERALOPDDEPERSONALIZATION,
    GETGENERALOPDGYNECOLOGICALHIST,
    CREATEGENERALOPDGYNECOLOGICALHIST,
    UPDATEGENERALOPDGYNECOLOGICALHIST,
    DELETEGENERALOPDGYNECOLOGICALHIST,
    GETGENERALOPDMENSTRUALCYCLEHIST,
    CREATEGENERALOPDMENSTRUALCYCLEHIST,
    UPDATEGENERALOPDMENSTRUALCYCLEHIST,
    DELETEGENERALOPDMENSTRUALCYCLEHIST,
    GETGENERALOPDOBSTETRICALHIST,
    CREATEGENERALOPDOBSTETRICALHIST,
    UPDATEGENERALOPDOBSTETRICALHIST,
    DELETEGENERALOPDOBSTETRICALHIST,
    GETGENERALOPDNATUREOFDELIVERY,
    CREATEGENERALOPDNATUREOFDELIVERY,
    UPDATEGENERALOPDNATUREOFDELIVERY,
    DELETEGENERALOPDNATUREOFDELIVERY,

    GETGENERALOPDEXAMGENERALLOOK,
    CREATEGENERALOPDEXAMGENERALLOOK,
    UPDATEGENERALOPDEXAMGENERALLOOK,
    DELETEGENERALOPDEXAMGENERALLOOK,
    GETGENERALOPDEXAMNUTRITION,
    CREATEGENERALOPDEXAMNUTRITION,
    UPDATEGENERALOPDEXAMNUTRITION,
    DELETEGENERALOPDEXAMNUTRITION,
    GETGENERALOPDEXAMANAEMIA,
    CREATEGENERALOPDEXAMANAEMIA,
    UPDATEGENERALOPDEXAMANAEMIA,
    DELETEGENERALOPDEXAMANAEMIA,
    GETGENERALOPDEXAMNECKVEIN,
    CREATEGENERALOPDEXAMNECKVEIN,
    UPDATEGENERALOPDEXAMNECKVEIN,
    DELETEGENERALOPDEXAMNECKVEIN,
    GETGENERALOPDEXAMLYMPHNODES,
    CREATEGENERALOPDEXAMLYMPHNODES,
    UPDATEGENERALOPDEXAMLYMPHNODES,
    DELETEGENERALOPDEXAMLYMPHNODES,
    GETGENERALOPDEXAMGENERALOTHERFIELDS,
    CREATEGENERALOPDEXAMGENERALOTHERFIELDS,
    UPDATEGENERALOPDEXAMGENERALOTHERFIELDS,
    DELETEGENERALOPDEXAMGENERALOTHERFIELDS,
    GETGENERALOPDEXAMVITALS,
    CREATEGENERALOPDEXAMVITALS,
    UPDATEGENERALOPDEXAMVITALS,
    DELETEGENERALOPDEXAMVITALS,
    GETGENERALOPDEXAMGENDER,
    CREATEGENERALOPDEXAMGENDER,
    UPDATEGENERALOPDEXAMGENDER,
    DELETEGENERALOPDEXAMGENDER,
    GETGENERALOPDEXAMSIGNOFDISTRESS,
    CREATEGENERALOPDEXAMSIGNOFDISTRESS,
    UPDATEGENERALOPDEXAMSIGNOFDISTRESS,
    DELETEGENERALOPDEXAMSIGNOFDISTRESS,
    GETGENERALOPDEXAMBODYTYPE,
    CREATEGENERALOPDEXAMBODYTYPE,
    UPDATEGENERALOPDEXAMBODYTYPE,
    DELETEGENERALOPDEXAMBODYTYPE,
    GETGENERALOPDEXAMPOSTURE,
    CREATEGENERALOPDEXAMPOSTURE,
    UPDATEGENERALOPDEXAMPOSTURE,
    DELETEGENERALOPDEXAMPOSTURE,
    GETGENERALOPDEXAMGAIT,
    CREATEGENERALOPDEXAMGAIT,
    UPDATEGENERALOPDEXAMGAIT,
    DELETEGENERALOPDEXAMGAIT,
    GETGENERALOPDEXAMBODYMOVEMENT,
    CREATEGENERALOPDEXAMBODYMOVEMENT,
    UPDATEGENERALOPDEXAMBODYMOVEMENT,
    DELETEGENERALOPDEXAMBODYMOVEMENT,
    GETGENERALOPDEXAMBODY,
    CREATEGENERALOPDEXAMBODY,
    UPDATEGENERALOPDEXAMBODY,
    DELETEGENERALOPDEXAMBODY,
    GETGENERALOPDEXAMAFFECTANDMOOD,
    CREATEGENERALOPDEXAMAFFECTANDMOOD,
    UPDATEGENERALOPDEXAMAFFECTANDMOOD,
    DELETEGENERALOPDEXAMAFFECTANDMOOD,
    GETGENERALOPDEXAMSPEECH,
    CREATEGENERALOPDEXAMSPEECH,
    UPDATEGENERALOPDEXAMSPEECH,
    DELETEGENERALOPDEXAMSPEECH,
    GETGENERALOPDEXAMSUBSTANCEABUSE,
    CREATEGENERALOPDEXAMSUBSTANCEABUSE,
    UPDATEGENERALOPDEXAMSUBSTANCEABUSE,
    DELETEGENERALOPDEXAMSUBSTANCEABUSE,
    GETGENERALOPDEXAMHAIRCOLOR,
    CREATEGENERALOPDEXAMHAIRCOLOR,
    UPDATEGENERALOPDEXAMHAIRCOLOR,
    DELETEGENERALOPDEXAMHAIRCOLOR,
    GETGENERALOPDEXAMHAIRDUSTRIBUTION,
    CREATEGENERALOPDEXAMHAIRDUSTRIBUTION,
    UPDATEGENERALOPDEXAMHAIRDUSTRIBUTION,
    DELETEGENERALOPDEXAMHAIRDUSTRIBUTION,
    GETGENERALOPDEXAMHAIRTEXTURE,
    CREATEGENERALOPDEXAMHAIRTEXTURE,
    UPDATEGENERALOPDEXAMHAIRTEXTURE,
    DELETEGENERALOPDEXAMHAIRTEXTURE,
    GETGENERALOPDEXAMHAIRLUBRICATON,
    CREATEGENERALOPDEXAMHAIRLUBRICATON,
    UPDATEGENERALOPDEXAMHAIRLUBRICATON,
    DELETEGENERALOPDEXAMHAIRLUBRICATON,
    GETGENERALOPDEXAMHAIRSCALP,
    CREATEGENERALOPDEXAMHAIRSCALP,
    UPDATEGENERALOPDEXAMHAIRSCALP,
    DELETEGENERALOPDEXAMHAIRSCALP,
    GETGENERALOPDEXAMHEADPOSITION,
    CREATEGENERALOPDEXAMHEADPOSITION,
    UPDATEGENERALOPDEXAMHEADPOSITION,
    DELETEGENERALOPDEXAMHEADPOSITION,
    GETGENERALOPDEXAMHEADSHAPE,
    CREATEGENERALOPDEXAMHEADSHAPE,
    UPDATEGENERALOPDEXAMHEADSHAPE,
    DELETEGENERALOPDEXAMHEADSHAPE,
    GETGENERALOPDEXAMFACIALFEATURES,
    CREATEGENERALOPDEXAMFACIALFEATURES,
    UPDATEGENERALOPDEXAMFACIALFEATURES,
    DELETEGENERALOPDEXAMFACIALFEATURES,
    GETGENERALOPDEXAMEXTERNALEYEPOSTION,
    CREATEGENERALOPDEXAMEXTERNALEYEPOSTION,
    UPDATEGENERALOPDEXAMEXTERNALEYEPOSTION,
    DELETEGENERALOPDEXAMEXTERNALEYEPOSTION,
    GETGENERALOPDEXAMHEADEYENECK,
    CREATEGENERALOPDEXAMHEADEYENECK,
    UPDATEGENERALOPDEXAMHEADEYENECK,
    DELETEGENERALOPDEXAMHEADEYENECK,
    GETGENERALOPDEXAMLACRIMALAAPPARATUS,
    CREATEGENERALOPDEXAMLACRIMALAAPPARATUS,
    UPDATEGENERALOPDEXAMLACRIMALAAPPARATUS,
    DELETEGENERALOPDEXAMLACRIMALAAPPARATUS,
    GETGENERALOPDEXAMCONJUCTIVASCLERACOLOR,
    CREATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR,
    UPDATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR,
    DELETEGENERALOPDEXAMCONJUCTIVASCLERACOLOR,
    GETGENERALOPDEXAMEXTRACOCULARMOVEMENT,
    CREATEGENERALOPDEXAMEXTRACOCULARMOVEMENT,
    UPDATEGENERALOPDEXAMEXTRACOCULARMOVEMENT,
    DELETEGENERALOPDEXAMEXTRACOCULARMOVEMENT,
    GETGENERALOPDEXAMNECKLYMPHNODE,
    CREATEGENERALOPDEXAMNECKLYMPHNODE,
    UPDATEGENERALOPDEXAMNECKLYMPHNODE,
    DELETEGENERALOPDEXAMNECKLYMPHNODE,
    GETGENERALOPDEXAMEARNOSEMOUTH,
    CREATEGENERALOPDEXAMEARNOSEMOUTH,
    UPDATEGENERALOPDEXAMEARNOSEMOUTH,
    DELETEGENERALOPDEXAMEARNOSEMOUTH,
    GETGENERALOPDEXAMCHESTAXILLATHORAX,
    CREATEGENERALOPDEXAMCHESTAXILLATHORAX,
    UPDATEGENERALOPDEXAMCHESTAXILLATHORAX,
    DELETEGENERALOPDEXAMCHESTAXILLATHORAX,
    GETGENERALOPDEXAMABDOMEN,
    CREATEGENERALOPDEXAMABDOMEN,
    UPDATEGENERALOPDEXAMABDOMEN,
    DELETEGENERALOPDEXAMABDOMEN,
    GETGENERALOPDEXAMEXTERNLGENITALORGAN,
    CREATEGENERALOPDEXAMEXTERNLGENITALORGAN,
    UPDATEGENERALOPDEXAMEXTERNLGENITALORGAN,
    DELETEGENERALOPDEXAMEXTERNLGENITALORGAN,
    GETGENERALOPDEXAMMUSCULOSKELETAL,
    CREATEGENERALOPDEXAMMUSCULOSKELETAL,
    UPDATEGENERALOPDEXAMMUSCULOSKELETAL,
    DELETEGENERALOPDEXAMMUSCULOSKELETAL,
    GETGENERALOPDEXAMNEURO,
    CREATEGENERALOPDEXAMNEURO,
    UPDATEGENERALOPDEXAMNEURO,
    DELETEGENERALOPDEXAMNEURO,


    CLEAR_OPD_CHIEF_COMPLAINT_LIST,
    CLEARGENERALMEDIASSOCIATEDCOMPLAINT,
    CLEARGENERALMEDIPRESENTILLNESSHIST,
    CLEARGENERALMEDICHILDHOODILLNESS,
    CLEARGENERALMEDIADULTILLNESS,
    CLEARGENERALMEDIHEALTHMAIN,
    CLEARGENERALMEDIPASTILLNESSNOTE,
    CLEARGENERALMEDIRELATIONHIST,
    CLEARGENERALMEDIFAMILYSYMPTOMS,
    CLEARGENERALMEDIFAMILYCOMORBIDITY,
    CLEARGENERALMEDIPERSONALDIET,
    CLEARGENERALMEDIAPPETITE,
    CLEARGENERALMEDIDIGESTIVETRACT,
    CLEARGENERALMEDIBOWEL,
    CLEARGENERALMEDISLEEP,
    CLEARGENERALMEDIADDICTIONS,
    CLEARGENERALMEDIHIGHRISK,
    CLEARGENERALMEDIPOSITIONOFWORK,
    CLEARGENERALMEDINATUREOFWORK,
    CLEARGENERALMEDIOCCUPATIONALHIST,
    CLEARGENERALMEDIALLOPATHICMEDI,
    CLEARGENERALMEDIAYURVEDAMEDI,
    CLEARGENERALMEDIHOMEOPATHYMEDI,
    CLEARGENERALMEDIOTHERMEDI,
    CLEARGENERALMEDIANXIETY,
    CLEARGENERALMEDDEPRESSION,
    CLEARGENERALMEDIIRRITABILITY,
    CLEARGENERALMEDIEUPHORIA,
    CLEARGENERALMEDIOBSESSION,
    CLEARGENERALMEDINEUROSIS,
    CLEARGENERALMEDIDEPERSONLIZATION,
    CLEARGENERALMEDIMENSTRUALCYCLE,
    CLEARGENERALMEDIGYNECOLOGICHIST,
    CLEARGENERALMEDINATUEOFDELIVERY,
    CLEARGENERALMEDIOBSTETRICAL,
    CLEARGENERALMEDIGENERALLOOK,
    CLEARGENERALMEDINUTRITION,
    CLEARGENERALMEDIANAEMIA,
    CLEARGENERALMEDINECKVEIN,
    CLEARGENERALMEDILYMPHNODE,
    CLEARGENERALMEDIGENERALEXAMINATION,
    CLEARGENERALMEDIVITALS,
    CLEARGENERALMEDIGENDER,
    CLEARGENERALMEDISIGNOFDISTRESS,
    CLEARGENERALMEDIBODYTYPE,
    CLEARGENERALMEDIPOSTURE,
    CLEARGENERALMEDIGAIT,
    CLEARGENERALMEDIBODYMOVEMENT,
    CLEARGENERALMEDIBODY,
    CLEARGENERALMEDIAFFECTANDMOOD,
    CLEARGENERALMEDISPEECH,
    CLEARGENERALMEDISUBSTANCEABUSE,
    CLEARGENERALMEDIHAIRCOLOR,
    CLEARGENERALMEDIHAIRDISTRIBUTION,
    CLEARGENERALMEDIHAIRTEXTURE,
    CLEARGENERALMEDIHAIRLUBRICATION,
    CLEARGENERALMEDISCALP,
    CLEARGENERALMEDIHEADEYENECK,
    CLEARGENERALMEDIHEADPOSITION,
    CLEARGENERALMEDIHEADSHAPE,
    CLEARGENERALMEDIFACIALFEATURES,
    CLEARGENERALMEDIEYEPOSITION,
    CLEARGENERALMEDILACRIMALAPPARATUS,
    CLEARGENERALMEDICONJUCTIVASCLERA,
    CLEARGENERALMEDIOCULARMOVEMENT,
    CLEARGENERALMEDINECKLYMPHNODE,
    CLEARGENERALMEDIEARNOSEMOUTHPHARYNX,
    CLEARGENERALMEDICHESTAXILLATHORAX,
    CLEARGENERALMEDIABDOMEN,
    CLEARGENERALMEDIGENITALORGANS,
    CLEARGENERALMEDIMUSCULOSKELETAL,
    CLEARGENERALMEDINEURO,

} from "../actions/types"

const initialState = {};

export default function GeneralMedicineOpdReducer(state = initialState, action) {
    switch (action.type) {

        case GETGENERALOPDBODYCHART:
            return {
                ...state,
                GeneralMediOpdBodyChartList: action.payload.data,
            }
        case CREATEGENERALOPDBODYCHART:
            return {
                ...state,
                GeneralMediOpdBodyChartSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDBODYCHART:
            return {
                ...state,
                GeneralMediOpdBodyChartUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDBODYCHART:
            return {
                ...state,
                GeneralMediOpdBodyChartDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDPAINASSESSMENT:
            return {
                ...state,
                GeneralMediOpdPainAssessmentList: action.payload.data,
            }
        case CREATEGENERALOPDPAINASSESSMENT:
            return {
                ...state,
                GeneralMediOpdPainAssessmentSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDPAINASSESSMENT:
            return {
                ...state,
                GeneralMediOpdPainAssessmentUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDPAINASSESSMENT:
            return {
                ...state,
                GeneralMediOpdPainAssessmentDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDCHIEFCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdChiefComplaintList: action.payload.data,
            }
        case CREATEGENERALOPDCHIEFCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdChiefComplaintSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDCHIEFCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdChiefComplaintUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDCHIEFCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdChiefComplaintDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDASSOCIATEDCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdAssociatedComplaintList: action.payload.data,
            }
        case CREATEGENERALOPDASSOCIATEDCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdAssociatedComplaintSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDASSOCIATEDCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdAssociatedComplaintUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDASSOCIATEDCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdAssociatedComplaintDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDPRESENTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdPresentIllnessHistList: action.payload.data,
            }
        case CREATEGENERALOPDPRESENTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdPresentIllnessHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDPRESENTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdPresentIllnessHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDPRESENTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdPresentIllnessHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDCHIDLILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdChildIllnessHistList: action.payload.data,
            }
        case CREATEGENERALOPDCHIDLILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdChildIllnessHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDCHIDLILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdChildIllnessHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDCHIDLILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdChildIllnessHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDADULTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdAdultIllnessHistList: action.payload.data,
            }
        case CREATEGENERALOPDADULTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdAdultIllnessHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDADULTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdAdultIllnessHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDADULTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdAdultIllnessHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDHEALTHMAINHIST:
            return {
                ...state,
                GeneralMediOpdHealthMainHistList: action.payload.data,
            }
        case CREATEGENERALOPDHEALTHMAINHIST:
            return {
                ...state,
                GeneralMediOpdHealthMainHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDHEALTHMAINHIST:
            return {
                ...state,
                GeneralMediOpdHealthMainHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDHEALTHMAINHIST:
            return {
                ...state,
                GeneralMediOpdHealthMainHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDPASTILLNESSNOTE:
            return {
                ...state,
                GeneralMediOpdPastillnessNoteList: action.payload.data,
            }
        case CREATEGENERALOPDPASTILLNESSNOTE:
            return {
                ...state,
                GeneralMediOpdPastillnessNoteSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDPASTILLNESSNOTE:
            return {
                ...state,
                GeneralMediOpdPastillnessNoteUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDPASTILLNESSNOTE:
            return {
                ...state,
                GeneralMediOpdPastillnessNoteDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDRELATIONHIST:
            return {
                ...state,
                GeneralMediOpdRelationList: action.payload.data,
            }
        case CREATEGENERALOPDRELATIONHIST:
            return {
                ...state,
                GeneralMediOpdRelationSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDRELATIONHIST:
            return {
                ...state,
                GeneralMediOpdRelationUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDRELATIONHIST:
            return {
                ...state,
                GeneralMediOpdRelationDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDFAMILYSYMPTOMHIST:
            return {
                ...state,
                GeneralMediOpdFamilySymptomsList: action.payload.data,
            }
        case CREATEGENERALOPDFAMILYSYMPTOMHIST:
            return {
                ...state,
                GeneralMediOpdFamilySymptomsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDFAMILYSYMPTOMHIST:
            return {
                ...state,
                GeneralMediOpdFamilySymptomsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDFAMILYSYMPTOMHIST:
            return {
                ...state,
                GeneralMediOpdFamilySymptomsDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDFAMILYCOMORBIDITYHIST:
            return {
                ...state,
                GeneralMediOpdFamilyComorbidityList: action.payload.data,
            }
        case CREATEGENERALOPDFAMILYCOMORBIDITYHIST:
            return {
                ...state,
                GeneralMediOpdFamilyComorbiditySaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDFAMILYCOMORBIDITYHIST:
            return {
                ...state,
                GeneralMediOpdFamilyComorbidityUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDFAMILYCOMORBIDITYHIST:
            return {
                ...state,
                GeneralMediOpdFamilyComorbidityDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDFAMILYHISTNOTE:
            return {
                ...state,
                GeneralMediOpdFamilyHistNoteList: action.payload.data,
            }
        case CREATEGENERALOPDFAMILYHISTNOTE:
            return {
                ...state,
                GeneralMediOpdFamilyHistNoteSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDFAMILYHISTNOTE:
            return {
                ...state,
                GeneralMediOpdFamilyHistNoteUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDFAMILYHISTNOTE:
            return {
                ...state,
                GeneralMediOpdFamilyHistNoteDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDPERSONALDIETHIST:
            return {
                ...state,
                GeneralMediOpdpersonaldiethistList: action.payload.data,
            }
        case CREATEGENERALOPDPERSONALDIETHIST:
            return {
                ...state,
                GeneralMediOpdpersonaldiethistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDPERSONALDIETHIST:
            return {
                ...state,
                GeneralMediOpdpersonaldiethistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDPERSONALDIETHIST:
            return {
                ...state,
                GeneralMediOpdpersonaldiethistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDAPPETITEHIST:
            return {
                ...state,
                GeneralMediOpdAppetiteHistList: action.payload.data,
            }
        case CREATEGENERALOPDAPPETITEHIST:
            return {
                ...state,
                GeneralMediOpdAppetiteHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDAPPETITEHIST:
            return {
                ...state,
                GeneralMediOpdAppetiteHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDAPPETITEHIST:
            return {
                ...state,
                GeneralMediOpdAppetiteHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDDIGESTIVETRACTHIST:
            return {
                ...state,
                GeneralMediOpdDigestiveTractHistList: action.payload.data,
            }
        case CREATEGENERALOPDDIGESTIVETRACTHIST:
            return {
                ...state,
                GeneralMediOpdDigestiveTractHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDDIGESTIVETRACTHIST:
            return {
                ...state,
                GeneralMediOpdDigestiveTractHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDDIGESTIVETRACTHIST:
            return {
                ...state,
                GeneralMediOpdDigestiveTractHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDBOWELHIST:
            return {
                ...state,
                GeneralMediOpdBowelHistList: action.payload.data,
            }
        case CREATEGENERALOPDBOWELHIST:
            return {
                ...state,
                GeneralMediOpdBowelHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDBOWELHIST:
            return {
                ...state,
                GeneralMediOpdBowelHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDBOWELHIST:
            return {
                ...state,
                GeneralMediOpdBowelHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDSLEEPHIST:
            return {
                ...state,
                GeneralMediOpdSleepHistList: action.payload.data,
            }
        case CREATEGENERALOPDSLEEPHIST:
            return {
                ...state,
                GeneralMediOpdSleepHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDSLEEPHIST:
            return {
                ...state,
                GeneralMediOpdSleepHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDSLEEPHIST:
            return {
                ...state,
                GeneralMediOpdSleepHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDADDICTIONHIST:
            return {
                ...state,
                GeneralMediOpdAddictionsHistList: action.payload.data,
            }
        case CREATEGENERALOPDADDICTIONHIST:
            return {
                ...state,
                GeneralMediOpdAddictionsHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDADDICTIONHIST:
            return {
                ...state,
                GeneralMediOpdAddictionsHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDADDICTIONHIST:
            return {
                ...state,
                GeneralMediOpdAddictionsHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDHIGHRISKHIST:
            return {
                ...state,
                GeneralMediOpdHighRiskHistList: action.payload.data,
            }
        case CREATEGENERALOPDHIGHRISKHIST:
            return {
                ...state,
                GeneralMediOpdHighRiskHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDHIGHRISKHIST:
            return {
                ...state,
                GeneralMediOpdHighRiskHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDHIGHRISKHIST:
            return {
                ...state,
                GeneralMediOpdHighRiskHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDPOSITIONODWORK:
            return {
                ...state,
                GeneralMediOpdPositionDuringWorkList: action.payload.data,
            }
        case CREATEGENERALOPDPOSITIONODWORK:
            return {
                ...state,
                GeneralMediOpdPositionDuringWorkSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDPOSITIONODWORK:
            return {
                ...state,
                GeneralMediOpdPositionDuringWorkUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDPOSITIONODWORK:
            return {
                ...state,
                GeneralMediOpdPositionDuringWorkDeleteStatus: action.payload.success,
            }

        case GETGENERALOPDNATUREOFWORK:
            return {
                ...state,
                GeneralMediOpdNatureOfWorkList: action.payload.data,
            }
        case CREATEGENERALOPDNATUREOFWORK:
            return {
                ...state,
                GeneralMediOpdNatureOfWorkSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDNATUREOFWORK:
            return {
                ...state,
                GeneralMediOpdNatureOfWorkUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDNATUREOFWORK:
            return {
                ...state,
                GeneralMediOpdNatureOfWorkDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDOCCUPATIONALHIST:
            return {
                ...state,
                GeneralMediOpdOccupationalHistList: action.payload.data,
            }
        case CREATEGENERALOPDOCCUPATIONALHIST:
            return {
                ...state,
                GeneralMediOpdOccupationalHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDOCCUPATIONALHIST:
            return {
                ...state,
                GeneralMediOpdOccupationalHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDOCCUPATIONALHIST:
            return {
                ...state,
                GeneralMediOpdOccupationalHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDALLOPTHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAllopathyMediHistList: action.payload.data,
            }
        case CREATEGENERALOPDALLOPTHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAllopathyMediHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDALLOPTHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAllopathyMediHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDALLOPTHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAllopathyMediHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDAYURVEDAMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAyurvedaMediHistList: action.payload.data,
            }
        case CREATEGENERALOPDAYURVEDAMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAyurvedaMediHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDAYURVEDAMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAyurvedaMediHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDAYURVEDAMEDIHIST:
            return {
                ...state,
                GeneralMediOpdAyurvedaMediHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDHOMEOPATHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdHomeopathyMediHistList: action.payload.data,
            }
        case CREATEGENERALOPDHOMEOPATHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdHomeopathyMediHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDHOMEOPATHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdHomeopathyMediHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDHOMEOPATHYMEDIHIST:
            return {
                ...state,
                GeneralMediOpdHomeopathyMediHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDOTHERMEDIHIST:
            return {
                ...state,
                GeneralMediOpdOtherMediHistList: action.payload.data,
            }
        case CREATEGENERALOPDOTHERMEDIHIST:
            return {
                ...state,
                GeneralMediOpdOtherMediHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDOTHERMEDIHIST:
            return {
                ...state,
                GeneralMediOpdOtherMediHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDOTHERMEDIHIST:
            return {
                ...state,
                GeneralMediOpdOtherMediHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDANXIETYHIST:
            return {
                ...state,
                GeneralMediOpdAnxietyHistList: action.payload.data,
            }
        case CREATEGENERALOPDANXIETYHIST:
            return {
                ...state,
                GeneralMediOpdAnxietyHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDANXIETYHIST:
            return {
                ...state,
                GeneralMediOpdAnxietyHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDANXIETYHIST:
            return {
                ...state,
                GeneralMediOpdAnxietyHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDDEPRESSIONHIST:
            return {
                ...state,
                GeneralMediOpdDepressionHistList: action.payload.data,
            }
        case CREATEGENERALOPDDEPRESSIONHIST:
            return {
                ...state,
                GeneralMediOpdDepressionHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDDEPRESSIONHIST:
            return {
                ...state,
                GeneralMediOpdDepressionHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDDEPRESSIONHIST:
            return {
                ...state,
                GeneralMediOpdDepressionHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDIRRITABILITYHIST:
            return {
                ...state,
                GeneralMediOpdIrritabilityHistList: action.payload.data,
            }
        case CREATEGENERALOPDIRRITABILITYHIST:
            return {
                ...state,
                GeneralMediOpdIrritabilityHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDIRRITABILITYHIST:
            return {
                ...state,
                GeneralMediOpdIrritabilityHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDIRRITABILITYHIST:
            return {
                ...state,
                GeneralMediOpdIrritabilityHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEUPHORIAHIST:
            return {
                ...state,
                GeneralMediOpdEuphoriaHistList: action.payload.data,
            }
        case CREATEGENERALOPDEUPHORIAHIST:
            return {
                ...state,
                GeneralMediOpdEuphoriaHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEUPHORIAHIST:
            return {
                ...state,
                GeneralMediOpdEuphoriaHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEUPHORIAHIST:
            return {
                ...state,
                GeneralMediOpdEuphoriaHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDOBSESSION:
            return {
                ...state,
                GeneralMediOpdObsessionHistList: action.payload.data,
            }
        case CREATEGENERALOPDOBSESSION:
            return {
                ...state,
                GeneralMediOpdObsessionHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDOBSESSION:
            return {
                ...state,
                GeneralMediOpdObsessionHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDOBSESSION:
            return {
                ...state,
                GeneralMediOpdObsessionHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDNEUROSISHIST:
            return {
                ...state,
                GeneralMediOpdNeurosisHistList: action.payload.data,
            }
        case CREATEGENERALOPDNEUROSISHIST:
            return {
                ...state,
                GeneralMediOpdNeurosisHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDNEUROSISHIST:
            return {
                ...state,
                GeneralMediOpdNeurosisHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDNEUROSISHIST:
            return {
                ...state,
                GeneralMediOpdNeurosisHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDDEPERSONALIZATION:
            return {
                ...state,
                GeneralMediOpdDepersonalizationHistList: action.payload.data,
            }
        case CREATEGENERALOPDDEPERSONALIZATION:
            return {
                ...state,
                GeneralMediOpdDepersonalizationHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDDEPERSONALIZATION:
            return {
                ...state,
                GeneralMediOpdDepersonalizationHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDDEPERSONALIZATION:
            return {
                ...state,
                GeneralMediOpdDepersonalizationHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDGYNECOLOGICALHIST:
            return {
                ...state,
                GeneralMediOpdGynecologicHistList: action.payload.data,
            }
        case CREATEGENERALOPDGYNECOLOGICALHIST:
            return {
                ...state,
                GeneralMediOpdGynecologicHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDGYNECOLOGICALHIST:
            return {
                ...state,
                GeneralMediOpdGynecologicHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDGYNECOLOGICALHIST:
            return {
                ...state,
                GeneralMediOpdGynecologicHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDMENSTRUALCYCLEHIST:
            return {
                ...state,
                GeneralMediOpdMenstrualCycleList: action.payload.data,
            }
        case CREATEGENERALOPDMENSTRUALCYCLEHIST:
            return {
                ...state,
                GeneralMediOpdMenstrualCycleSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDMENSTRUALCYCLEHIST:
            return {
                ...state,
                GeneralMediOpdMenstrualCycleUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDMENSTRUALCYCLEHIST:
            return {
                ...state,
                GeneralMediOpdMenstrualCycleDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDOBSTETRICALHIST:
            return {
                ...state,
                GeneralMediOpdObstetricalHistList: action.payload.data,
            }
        case CREATEGENERALOPDOBSTETRICALHIST:
            return {
                ...state,
                GeneralMediOpdObstetricalHistSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDOBSTETRICALHIST:
            return {
                ...state,
                GeneralMediOpdObstetricalHistUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDOBSTETRICALHIST:
            return {
                ...state,
                GeneralMediOpdObstetricalHistDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDNATUREOFDELIVERY:
            return {
                ...state,
                GeneralMediOpdNatureOfDeliveryList: action.payload.data,
            }
        case CREATEGENERALOPDNATUREOFDELIVERY:
            return {
                ...state,
                GeneralMediOpdNatureOfDeliverySaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDNATUREOFDELIVERY:
            return {
                ...state,
                GeneralMediOpdNatureOfDeliveryUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDNATUREOFDELIVERY:
            return {
                ...state,
                GeneralMediOpdNatureOfDeliveryDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMGENERALLOOK:
            return {
                ...state,
                GeneralMediOpdExamGenerallokList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMGENERALLOOK:
            return {
                ...state,
                GeneralMediOpdExamGenerallokSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMGENERALLOOK:
            return {
                ...state,
                GeneralMediOpdExamGenerallokUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMGENERALLOOK:
            return {
                ...state,
                GeneralMediOpdExamGenerallokDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMNUTRITION:
            return {
                ...state,
                GeneralMediOpdExamNutritionList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMNUTRITION:
            return {
                ...state,
                GeneralMediOpdExamNutritionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMNUTRITION:
            return {
                ...state,
                GeneralMediOpdExamNutritionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMNUTRITION:
            return {
                ...state,
                GeneralMediOpdExamNutritionDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMANAEMIA:
            return {
                ...state,
                GeneralMediOpdExamAnaemiaList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMANAEMIA:
            return {
                ...state,
                GeneralMediOpdExamAnaemiaSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMANAEMIA:
            return {
                ...state,
                GeneralMediOpdExamAnaemiaUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMANAEMIA:
            return {
                ...state,
                GeneralMediOpdExamAnaemiaDeleteStatus: action.payload.success,
            }

        case GETGENERALOPDEXAMNECKVEIN:
            return {
                ...state,
                GeneralMediOpdExamNeckVeinList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMNECKVEIN:
            return {
                ...state,
                GeneralMediOpdExamNeckVeinSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMNECKVEIN:
            return {
                ...state,
                GeneralMediOpdExamNeckVeinUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMNECKVEIN:
            return {
                ...state,
                GeneralMediOpdExamNeckVeinDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMLYMPHNODES:
            return {
                ...state,
                GeneralMediOpdExamLymphnodeList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMLYMPHNODES:
            return {
                ...state,
                GeneralMediOpdExamLymphnodeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMLYMPHNODES:
            return {
                ...state,
                GeneralMediOpdExamLymphnodeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMLYMPHNODES:
            return {
                ...state,
                GeneralMediOpdExamLymphnodeDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMGENERALOTHERFIELDS:
            return {
                ...state,
                GeneralMediOpdExamGeneralOtherFieldsList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMGENERALOTHERFIELDS:
            return {
                ...state,
                GeneralMediOpdExamGeneralOtherFieldsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMGENERALOTHERFIELDS:
            return {
                ...state,
                GeneralMediOpdExamGeneralOtherFieldsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMGENERALOTHERFIELDS:
            return {
                ...state,
                GeneralMediOpdExamGeneralOtherFieldsDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMVITALS:
            return {
                ...state,
                GeneralMediOpdExamVitalsList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMVITALS:
            return {
                ...state,
                GeneralMediOpdExamVitalsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMVITALS:
            return {
                ...state,
                GeneralMediOpdExamVitalsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMVITALS:
            return {
                ...state,
                GeneralMediOpdExamVitalsDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMGENDER:
            return {
                ...state,
                GeneralMediOpdExamGenderList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMGENDER:
            return {
                ...state,
                GeneralMediOpdExamGenderSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMGENDER:
            return {
                ...state,
                GeneralMediOpdExamGenderUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMGENDER:
            return {
                ...state,
                GeneralMediOpdExamGenderDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMSIGNOFDISTRESS:
            return {
                ...state,
                GeneralMediOpdExamSignOfDistressList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMSIGNOFDISTRESS:
            return {
                ...state,
                GeneralMediOpdExamSignOfDistressSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMSIGNOFDISTRESS:
            return {
                ...state,
                GeneralMediOpdExamSignOfDistressUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMSIGNOFDISTRESS:
            return {
                ...state,
                GeneralMediOpdExamSignOfDistressDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMBODYTYPE:
            return {
                ...state,
                GeneralMediOpdExamBodyTypeList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMBODYTYPE:
            return {
                ...state,
                GeneralMediOpdExamBodyTypeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMBODYTYPE:
            return {
                ...state,
                GeneralMediOpdExamBodyTypeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMBODYTYPE:
            return {
                ...state,
                GeneralMediOpdExamBodyTypeDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMPOSTURE:
            return {
                ...state,
                GeneralMediOpdExamPostureList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMPOSTURE:
            return {
                ...state,
                GeneralMediOpdExamPostureSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMPOSTURE:
            return {
                ...state,
                GeneralMediOpdExamPostureUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMPOSTURE:
            return {
                ...state,
                GeneralMediOpdExamPostureDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMGAIT:
            return {
                ...state,
                GeneralMediOpdExamGaitList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMGAIT:
            return {
                ...state,
                GeneralMediOpdExamGaitSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMGAIT:
            return {
                ...state,
                GeneralMediOpdExamGaitUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMGAIT:
            return {
                ...state,
                GeneralMediOpdExamGaitDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMBODYMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamBodyMovementList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMBODYMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamBodyMovementSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMBODYMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamBodyMovementUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMBODYMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamBodyMovementDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMBODY:
            return {
                ...state,
                GeneralMediOpdExamBodyList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMBODY:
            return {
                ...state,
                GeneralMediOpdExamBodySaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMBODY:
            return {
                ...state,
                GeneralMediOpdExamBodyUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMBODY:
            return {
                ...state,
                GeneralMediOpdExamBodyDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMAFFECTANDMOOD:
            return {
                ...state,
                GeneralMediOpdExamAffectandMoodList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMAFFECTANDMOOD:
            return {
                ...state,
                GeneralMediOpdExamAffectandMoodSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMAFFECTANDMOOD:
            return {
                ...state,
                GeneralMediOpdExamAffectandMoodUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMAFFECTANDMOOD:
            return {
                ...state,
                GeneralMediOpdExamAffectandMoodDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMSPEECH:
            return {
                ...state,
                GeneralMediOpdExamSpeechList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMSPEECH:
            return {
                ...state,
                GeneralMediOpdExamSpeechSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMSPEECH:
            return {
                ...state,
                GeneralMediOpdExamSpeechUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMSPEECH:
            return {
                ...state,
                GeneralMediOpdExamSpeechDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMSUBSTANCEABUSE:
            return {
                ...state,
                GeneralMediOpdExamSubstanceAbuseList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMSUBSTANCEABUSE:
            return {
                ...state,
                GeneralMediOpdExamSubstanceAbuseSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMSUBSTANCEABUSE:
            return {
                ...state,
                GeneralMediOpdExamSubstanceAbuseUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMSUBSTANCEABUSE:
            return {
                ...state,
                GeneralMediOpdExamSubstanceAbuseDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHAIRCOLOR:
            return {
                ...state,
                GeneralMediOpdExamHaircolorList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHAIRCOLOR:
            return {
                ...state,
                GeneralMediOpdExamHaircolorSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHAIRCOLOR:
            return {
                ...state,
                GeneralMediOpdExamHaircolorUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHAIRCOLOR:
            return {
                ...state,
                GeneralMediOpdExamHaircolorDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHAIRDUSTRIBUTION:
            return {
                ...state,
                GeneralMediOpdExamHairDistributionList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHAIRDUSTRIBUTION:
            return {
                ...state,
                GeneralMediOpdExamHairDistributionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHAIRDUSTRIBUTION:
            return {
                ...state,
                GeneralMediOpdExamHairDistributionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHAIRDUSTRIBUTION:
            return {
                ...state,
                GeneralMediOpdExamHairDistributionDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHAIRTEXTURE:
            return {
                ...state,
                GeneralMediOpdExamHairTextureList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHAIRTEXTURE:
            return {
                ...state,
                GeneralMediOpdExamHairTextureSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHAIRTEXTURE:
            return {
                ...state,
                GeneralMediOpdExamHairTextureUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHAIRTEXTURE:
            return {
                ...state,
                GeneralMediOpdExamHairTextureDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHAIRLUBRICATON:
            return {
                ...state,
                GeneralMediOpdExamLubricationList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHAIRLUBRICATON:
            return {
                ...state,
                GeneralMediOpdExamLubricationSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHAIRLUBRICATON:
            return {
                ...state,
                GeneralMediOpdExamLubricationUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHAIRLUBRICATON:
            return {
                ...state,
                GeneralMediOpdExamLubricationDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHAIRSCALP:
            return {
                ...state,
                GeneralMediOpdExamhairscalpList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHAIRSCALP:
            return {
                ...state,
                GeneralMediOpdExamhairscalpSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHAIRSCALP:
            return {
                ...state,
                GeneralMediOpdExamhairscalpUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHAIRSCALP:
            return {
                ...state,
                GeneralMediOpdExamhairscalpDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHEADPOSITION:
            return {
                ...state,
                GeneralMediOpdExamHeadPositionList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHEADPOSITION:
            return {
                ...state,
                GeneralMediOpdExamHeadPositionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHEADPOSITION:
            return {
                ...state,
                GeneralMediOpdExamHeadPositionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHEADPOSITION:
            return {
                ...state,
                GeneralMediOpdExamHeadPositionDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHEADSHAPE:
            return {
                ...state,
                GeneralMediOpdExamHeadShapeList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHEADSHAPE:
            return {
                ...state,
                GeneralMediOpdExamHeadShapeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHEADSHAPE:
            return {
                ...state,
                GeneralMediOpdExamHeadShapeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHEADSHAPE:
            return {
                ...state,
                GeneralMediOpdExamHeadShapeDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMFACIALFEATURES:
            return {
                ...state,
                GeneralMediOpdExamFacialFeaturesList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMFACIALFEATURES:
            return {
                ...state,
                GeneralMediOpdExamFacialFeaturesSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMFACIALFEATURES:
            return {
                ...state,
                GeneralMediOpdExamFacialFeaturesUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMFACIALFEATURES:
            return {
                ...state,
                GeneralMediOpdExamFacialFeaturesDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMEXTERNALEYEPOSTION:
            return {
                ...state,
                GeneralMediOpdExamExternalEyePositionList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMEXTERNALEYEPOSTION:
            return {
                ...state,
                GeneralMediOpdExamExternalEyePositionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMEXTERNALEYEPOSTION:
            return {
                ...state,
                GeneralMediOpdExamExternalEyePositionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMEXTERNALEYEPOSTION:
            return {
                ...state,
                GeneralMediOpdExamExternalEyePositionDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMHEADEYENECK:
            return {
                ...state,
                GeneralMediOpdExamHeadEyeNeckList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMHEADEYENECK:
            return {
                ...state,
                GeneralMediOpdExamHeadEyeNeckSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMHEADEYENECK:
            return {
                ...state,
                GeneralMediOpdExamHeadEyeNeckUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMHEADEYENECK:
            return {
                ...state,
                GeneralMediOpdExamHeadEyeNeckDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMLACRIMALAAPPARATUS:
            return {
                ...state,
                GeneralMediOpdExamLacrimalApparatusList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMLACRIMALAAPPARATUS:
            return {
                ...state,
                GeneralMediOpdExamLacrimalApparatusSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMLACRIMALAAPPARATUS:
            return {
                ...state,
                GeneralMediOpdExamLacrimalApparatusUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMLACRIMALAAPPARATUS:
            return {
                ...state,
                GeneralMediOpdExamLacrimalApparatusDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMCONJUCTIVASCLERACOLOR:
            return {
                ...state,
                GeneralMediOpdExamConjuctivaScleraColorList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR:
            return {
                ...state,
                GeneralMediOpdExamConjuctivaScleraColorSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR:
            return {
                ...state,
                GeneralMediOpdExamConjuctivaScleraColorUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMCONJUCTIVASCLERACOLOR:
            return {
                ...state,
                GeneralMediOpdExamConjuctivaScleraColorDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMEXTRACOCULARMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamOcularMovementList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMEXTRACOCULARMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamOcularMovementSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMEXTRACOCULARMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamOcularMovementUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMEXTRACOCULARMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamOcularMovementDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMNECKLYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamNeckLymphNodeList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMNECKLYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamNeckLymphNodeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMNECKLYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamNeckLymphNodeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMNECKLYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamNeckLymphNodeDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMEARNOSEMOUTH:
            return {
                ...state,
                GeneralMediOpdExamEarNoseMouthList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMEARNOSEMOUTH:
            return {
                ...state,
                GeneralMediOpdExamEarNoseMouthSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMEARNOSEMOUTH:
            return {
                ...state,
                GeneralMediOpdExamEarNoseMouthUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMEARNOSEMOUTH:
            return {
                ...state,
                GeneralMediOpdExamEarNoseMouthDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMCHESTAXILLATHORAX:
            return {
                ...state,
                GeneralMediOpdExamChestAxillaThoraxList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMCHESTAXILLATHORAX:
            return {
                ...state,
                GeneralMediOpdExamChestAxillaThoraxSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMCHESTAXILLATHORAX:
            return {
                ...state,
                GeneralMediOpdExamChestAxillaThoraxUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMCHESTAXILLATHORAX:
            return {
                ...state,
                GeneralMediOpdExamChestAxillaThoraxDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMABDOMEN:
            return {
                ...state,
                GeneralMediOpdExamAbdomenList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMABDOMEN:
            return {
                ...state,
                GeneralMediOpdExamAbdomenSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMABDOMEN:
            return {
                ...state,
                GeneralMediOpdExamAbdomenUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMABDOMEN:
            return {
                ...state,
                GeneralMediOpdExamAbdomenDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMEXTERNLGENITALORGAN:
            return {
                ...state,
                GeneralMediOpdExamGenitalOrgansList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMEXTERNLGENITALORGAN:
            return {
                ...state,
                GeneralMediOpdExamGenitalOrgansSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMEXTERNLGENITALORGAN:
            return {
                ...state,
                GeneralMediOpdExamGenitalOrgansUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMEXTERNLGENITALORGAN:
            return {
                ...state,
                GeneralMediOpdExamGenitalOrgansDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMMUSCULOSKELETAL:
            return {
                ...state,
                GeneralMediOpdExamMusculoSkeletalList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMMUSCULOSKELETAL:
            return {
                ...state,
                GeneralMediOpdExamMusculoSkeletalSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMMUSCULOSKELETAL:
            return {
                ...state,
                GeneralMediOpdExamMusculoSkeletalUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMMUSCULOSKELETAL:
            return {
                ...state,
                GeneralMediOpdExamMusculoSkeletalDeleteStatus: action.payload.success,
            }
        case GETGENERALOPDEXAMNEURO:
            return {
                ...state,
                GeneralMediOpdExamNeuroList: action.payload.data,
            }
        case CREATEGENERALOPDEXAMNEURO:
            return {
                ...state,
                GeneralMediOpdExamNeuroSaveStatus: action.payload.success,
            }
        case UPDATEGENERALOPDEXAMNEURO:
            return {
                ...state,
                GeneralMediOpdExamNeuroUpdateStatus: action.payload.success,
            }
        case DELETEGENERALOPDEXAMNEURO:
            return {
                ...state,
                GeneralMediOpdExamNeuroDeleteStatus: action.payload.success,
            }

        case CLEAR_OPD_CHIEF_COMPLAINT_LIST:
            return {
                ...state,
                GeneralMediOpdChiefComplaintList: [], // Clears the list in Redux
            };
        case CLEARGENERALMEDIASSOCIATEDCOMPLAINT:
            return {
                ...state,
                GeneralMediOpdAssociatedComplaintList: [], // Clears the list in Redux
            };
        case CLEARGENERALMEDIPRESENTILLNESSHIST:
            return {
                ...state,
                GeneralMediOpdPresentIllnessHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDICHILDHOODILLNESS:
            return {
                ...state,
                GeneralMediOpdChildIllnessHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIADULTILLNESS:
            return {
                ...state,
                GeneralMediOpdAdultIllnessHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHEALTHMAIN:
            return {
                ...state,
                GeneralMediOpdHealthMainHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIPASTILLNESSNOTE:
            return {
                ...state,
                GeneralMediOpdFamilyHistNoteList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIRELATIONHIST:
            return {
                ...state,
                GeneralMediOpdRelationList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIFAMILYSYMPTOMS:
            return {
                ...state,
                GeneralMediOpdFamilySymptomsList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIFAMILYCOMORBIDITY:
            return {
                ...state,
                GeneralMediOpdFamilyComorbidityList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIPERSONALDIET:
            return {
                ...state,
                GeneralMediOpdpersonaldiethistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIAPPETITE:
            return {
                ...state,
                GeneralMediOpdAppetiteHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIDIGESTIVETRACT:
            return {
                ...state,
                GeneralMediOpdDigestiveTractHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIBOWEL:
            return {
                ...state,
                GeneralMediOpdBowelHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDISLEEP:
            return {
                ...state,
                GeneralMediOpdSleepHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIADDICTIONS:
            return {
                ...state,
                GeneralMediOpdAddictionsHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHIGHRISK:
            return {
                ...state,
                GeneralMediOpdHighRiskHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIPOSITIONOFWORK:
            return {
                ...state,
                GeneralMediOpdPositionDuringWorkList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINATUREOFWORK:
            return {
                ...state,
                GeneralMediOpdNatureOfWorkList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIOCCUPATIONALHIST:
            return {
                ...state,
                GeneralMediOpdOccupationalHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIALLOPATHICMEDI:
            return {
                ...state,
                GeneralMediOpdAllopathyMediHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIAYURVEDAMEDI:
            return {
                ...state,
                GeneralMediOpdAyurvedaMediHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHOMEOPATHYMEDI:
            return {
                ...state,
                GeneralMediOpdHomeopathyMediHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIOTHERMEDI:
            return {
                ...state,
                GeneralMediOpdOtherMediHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIANXIETY:
            return {
                ...state,
                GeneralMediOpdAnxietyHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDDEPRESSION:
            return {
                ...state,
                GeneralMediOpdDepressionHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIIRRITABILITY:
            return {
                ...state,
                GeneralMediOpdIrritabilityHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIEUPHORIA:
            return {
                ...state,
                GeneralMediOpdEuphoriaHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIOBSESSION:
            return {
                ...state,
                GeneralMediOpdObsessionHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINEUROSIS:
            return {
                ...state,
                GeneralMediOpdNeurosisHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIDEPERSONLIZATION:
            return {
                ...state,
                GeneralMediOpdDepersonalizationHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGYNECOLOGICHIST:
            return {
                ...state,
                GeneralMediOpdGynecologicHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIMENSTRUALCYCLE:
            return {
                ...state,
                GeneralMediOpdMenstrualCycleList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIOBSTETRICAL:
            return {
                ...state,
                GeneralMediOpdObstetricalHistList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINATUEOFDELIVERY:
            return {
                ...state,
                GeneralMediOpdNatureOfDeliveryList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGENERALLOOK:
            return {
                ...state,
                GeneralMediOpdExamGenerallokList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINUTRITION:
            return {
                ...state,
                GeneralMediOpdExamNutritionList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIANAEMIA:
            return {
                ...state,
                GeneralMediOpdExamAnaemiaList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINECKVEIN:
            return {
                ...state,
                GeneralMediOpdExamNeckVeinList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDILYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamLymphnodeList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGENERALEXAMINATION:
            return {
                ...state,
                GeneralMediOpdExamGeneralOtherFieldsList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIVITALS:
            return {
                ...state,
                GeneralMediOpdExamVitalsList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGENDER:
            return {
                ...state,
                GeneralMediOpdExamGenderList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDISIGNOFDISTRESS:
            return {
                ...state,
                GeneralMediOpdExamSignOfDistressList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIBODYTYPE:
            return {
                ...state,
                GeneralMediOpdExamBodyTypeList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIPOSTURE:
            return {
                ...state,
                GeneralMediOpdExamPostureList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGAIT:
            return {
                ...state,
                GeneralMediOpdExamGaitList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIBODYMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamBodyMovementList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIBODY:
            return {
                ...state,
                GeneralMediOpdExamBodyList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIAFFECTANDMOOD:
            return {
                ...state,
                GeneralMediOpdExamAffectandMoodList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDISPEECH:
            return {
                ...state,
                GeneralMediOpdExamSpeechList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDISUBSTANCEABUSE:
            return {
                ...state,
                GeneralMediOpdExamSubstanceAbuseList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHAIRCOLOR:
            return {
                ...state,
                GeneralMediOpdExamHaircolorList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHAIRDISTRIBUTION:
            return {
                ...state,
                GeneralMediOpdExamHairDistributionList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHAIRTEXTURE:
            return {
                ...state,
                GeneralMediOpdExamHairTextureList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHAIRLUBRICATION:
            return {
                ...state,
                GeneralMediOpdExamLubricationList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDISCALP:
            return {
                ...state,
                GeneralMediOpdExamhairscalpList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHEADPOSITION:
            return {
                ...state,
                GeneralMediOpdExamHeadPositionList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIHEADSHAPE:
            return {
                ...state,
                GeneralMediOpdExamHeadShapeList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIFACIALFEATURES:
            return {
                ...state,
                GeneralMediOpdExamFacialFeaturesList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIEYEPOSITION:
            return {
                ...state,
                GeneralMediOpdExamExternalEyePositionList: [], // Clears the list in Redux
            };
        case CLEARGENERALMEDIHEADEYENECK:
            return {
                ...state,
                GeneralMediOpdExamHeadEyeNeckList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDILACRIMALAPPARATUS:
            return {
                ...state,
                GeneralMediOpdExamLacrimalApparatusList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDICONJUCTIVASCLERA:
            return {
                ...state,
                GeneralMediOpdExamConjuctivaScleraColorList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIOCULARMOVEMENT:
            return {
                ...state,
                GeneralMediOpdExamOcularMovementList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINECKLYMPHNODE:
            return {
                ...state,
                GeneralMediOpdExamNeckLymphNodeList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIEARNOSEMOUTHPHARYNX:
            return {
                ...state,
                GeneralMediOpdExamEarNoseMouthList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDICHESTAXILLATHORAX:
            return {
                ...state,
                GeneralMediOpdExamChestAxillaThoraxList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIABDOMEN:
            return {
                ...state,
                GeneralMediOpdExamAbdomenList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIGENITALORGANS:
            return {
                ...state,
                GeneralMediOpdExamGenitalOrgansList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDIMUSCULOSKELETAL:
            return {
                ...state,
                GeneralMediOpdExamMusculoSkeletalList: [], // Clears the list in Redux
            }; case CLEARGENERALMEDINEURO:
            return {
                ...state,
                GeneralMediOpdExamNeuroList: [], // Clears the list in Redux
            };


        default:
            return state;
    }
}
